
















import { Vue, Component, Prop } from "@/shared/vuepack";
import PartnerMonthlyEmployerReport from "./PartnerMonthlyEmployerReport.vue";
import { useBillingStore } from "@/shared/store/billing";

@Component({
  components: {
    PartnerMonthlyEmployerReport
  }
})

export default class PartnerBillingReport extends Vue {

  billingStore = useBillingStore();

  @Prop() partnerId: number;

  get selectableBillingPeriods () { return this.billingStore.getSelectableBillingPeriods; }
  get employers () { return this.billingStore.getBillingEmployers; }
  get periodsLoaded () { return this.billingStore.getMonthlyBillingPeriodsLoaded; }
  get loadBillingPeriodsByPartner () { return this.billingStore.loadMonthlyBillingPeriodsByPartner; }
  get resetBillingPeriodsState () { return this.billingStore.resetBilling; }
  get downloadReportForPartner () { return this.billingStore.downloadPartnerReport; }
  get setPeriod () { return this.billingStore.setBillingPeriodId; }
  get setEmployer () { return this.billingStore.setBillingEmployer; }
}


